export default "/assets/images/app-notification-video.mp4?f2866cb0dd0fa5bd57835f8a74a81887";